import { resources } from "./resources";

const IS_IFC_ENABLED = true;
const IS_DT_BASIC_ENABLED = true;

export const roles = {
  ADMIN: {
    permissions: [
      ...(IS_DT_BASIC_ENABLED ? [resources.ADD_BUILDING.VIEW] : []),
      resources.BUILDING_PROFILE.DOWNLOAD_FILES,
      resources.BUILDING_PROFILE.UPLOAD_FILES,
      resources.BUILDING_PROFILE.DELETE_FILE,
      resources.BUILDING_PROFILE.UPLOAD_IMAGE,
      resources.BUILDING_PROFILE.THREE_D_VIEWER,
      resources.TECHNICAL_DATA.DOWNLOAD_FILES,
      resources.TECHNICAL_DATA.UPLOAD_FILES,
      resources.TECHNICAL_DATA.SELECT_COLUMNS,
      resources.TECHNICAL_DATA.REMOVE_ROW,
      resources.TECHNICAL_DATA.EDIT_TABLE_CELL,
      resources.ENERGY_PERFORMANCE.DOWNLOAD_FILES,
      resources.CERTIFICATE.DOWNLOAD_FILES,
      resources.MODERNIZATION.DOWNLOAD_SCENARIOS,
      resources.MODERNIZATION.CUSTOM_SCENARIO_UPLOAD,
    ],
    roleId: 4,
  },
  ASSET_MANAGER: {
    permissions: [
      resources.BUILDING_PROFILE.DOWNLOAD_FILES,
      resources.BUILDING_PROFILE.UPLOAD_FILES,
      resources.BUILDING_PROFILE.DELETE_FILE,
      resources.BUILDING_PROFILE.UPLOAD_IMAGE,
      resources.BUILDING_PROFILE.THREE_D_VIEWER,
      resources.TECHNICAL_DATA.DOWNLOAD_FILES,
      resources.TECHNICAL_DATA.UPLOAD_FILES,
      resources.TECHNICAL_DATA.SELECT_COLUMNS,
      resources.ENERGY_PERFORMANCE.DOWNLOAD_FILES,
      resources.CERTIFICATE.DOWNLOAD_FILES,
      resources.MODERNIZATION.DOWNLOAD_SCENARIOS,
      resources.MODERNIZATION.CUSTOM_SCENARIO_UPLOAD,
      resources.GOOGLE_ANALYTICS,
    ],
    roleId: 2,
  },
  GUEST: {
    permissions: [],
    roleId: 0,
  },
  LOGGED_IN: {
    permissions: [
      resources.BUILDING_PROFILE.DOWNLOAD_FILES,
      resources.BUILDING_PROFILE.THREE_D_VIEWER,
      resources.TECHNICAL_DATA.DOWNLOAD_FILES,
      resources.TECHNICAL_DATA.SELECT_COLUMNS,
      resources.ENERGY_PERFORMANCE.DOWNLOAD_FILES,
      resources.CERTIFICATE.DOWNLOAD_FILES,
      resources.MODERNIZATION.DOWNLOAD_SCENARIOS,
      resources.GOOGLE_ANALYTICS,
    ],
    roleId: 1,
  },
  SUPERUSER_ADMIN: {
    permissions: [
      ...(IS_DT_BASIC_ENABLED ? [resources.ADD_BUILDING.VIEW] : []),
      resources.BUILDING_PROFILE.DOWNLOAD_FILES,
      resources.BUILDING_PROFILE.UPLOAD_FILES,
      resources.BUILDING_PROFILE.DELETE_FILE,
      resources.BUILDING_PROFILE.UPLOAD_IMAGE,
      resources.BUILDING_PROFILE.THREE_D_VIEWER,
      resources.TECHNICAL_DATA.DOWNLOAD_FILES,
      resources.TECHNICAL_DATA.UPLOAD_FILES,
      resources.TECHNICAL_DATA.SELECT_COLUMNS,
      resources.TECHNICAL_DATA.REMOVE_ROW,
      resources.TECHNICAL_DATA.EDIT_TABLE_CELL,
      resources.ENERGY_PERFORMANCE.DOWNLOAD_FILES,
      resources.CERTIFICATE.DOWNLOAD_FILES,
      resources.MODERNIZATION.DOWNLOAD_SCENARIOS,
      resources.MODERNIZATION.CUSTOM_SCENARIO_UPLOAD,
    ],
    roleId: 32,
  },
  TEMP_ADMIN: {
    permissions: [
      ...(IS_DT_BASIC_ENABLED ? [resources.ADD_BUILDING.VIEW] : []),
      resources.BUILDING_PROFILE.DOWNLOAD_FILES,
      resources.BUILDING_PROFILE.UPLOAD_FILES,
      resources.BUILDING_PROFILE.DELETE_FILE,
      resources.BUILDING_PROFILE.UPLOAD_IMAGE,
      resources.BUILDING_PROFILE.THREE_D_VIEWER,
      resources.TECHNICAL_DATA.DOWNLOAD_FILES,
      resources.TECHNICAL_DATA.UPLOAD_FILES,
      resources.TECHNICAL_DATA.SELECT_COLUMNS,
      resources.TECHNICAL_DATA.REMOVE_ROW,
      resources.TECHNICAL_DATA.EDIT_TABLE_CELL,
      resources.ENERGY_PERFORMANCE.DOWNLOAD_FILES,
      resources.CERTIFICATE.DOWNLOAD_FILES,
      resources.MODERNIZATION.DOWNLOAD_SCENARIOS,
      resources.MODERNIZATION.CUSTOM_SCENARIO_UPLOAD,
      ...(IS_IFC_ENABLED ? [resources.EXECUTION.VIEW] : []),
      ...(IS_IFC_ENABLED ? [resources.EXECUTION.RUN] : []),
    ],
    roleId: 64,
  },
};
